import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerComponent } from './components/divider/divider.component';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [DividerComponent],
  exports: [DividerComponent],
  imports: [CommonModule, DividerModule],
})
export class PanelModule {}
